export const formatErrorDate = (date) => {
  //format DateObject to  5/20/2023 — 11:03:00 AM
  return new Date(date).toLocaleString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
